import { Col, Row } from "antd";
import React from "react";
import { ContentInputField } from "../../../../../components/atoms/formFields/inputField/contentInputField";
import SelectOption from "../../../../../components/atoms/formFields/selectOption";

const FullDetails = ({ productbase, detail }) => {
  return (
    <Row gutter={[12, 12]}>
      <Col xs={24}>
        <h6 className="font-weight-bolder">Product Details</h6>
      </Col>

      <Col xs={12} lg={8}>
        <ContentInputField
          disabled={true}
          value={detail?.productDetails?.productType?.en}
          name="Selected Type of Product"
        />
      </Col>

      {productbase !== "SEEDS" && productbase !== "MACHINERY" && (
        <>
          <Col xs={12} lg={8}>
            <ContentInputField
              value={detail?.productDetails?.physicalForm?.en}
              disabled={true}
              name="Selected Physical Form / State"
            />
          </Col>
        </>
      )}

      {productbase === "MACHINERY" && (
        <>
          <Col xs={12} lg={8}>
            <ContentInputField
              value={detail?.productDetails?.machineryType?.en}
              disabled={true}
              name="Selected Type of Machinery"
            />
          </Col>
        </>
      )}

      <Col xs={12} lg={8}>
        <ContentInputField
          value={detail?.productDetails?.brand?.name?.en}
          disabled={true}
          name="Brand Name"
        />
      </Col>

      {productbase === "SEEDS" && <Col xs={12} lg={8}></Col>}

      <Col xs={12} lg={8}>
        <ContentInputField
          name={
            productbase === "MACHINERY"
              ? detail?.productDetails?.machineryType?.en === "Equipment"
                ? "Equipment"
                : "Machinery"
              : "Product" + " Name English"
          }
          disabled={true}
          value={detail?.name?.en}
        />
      </Col>

      <Col xs={12} lg={8}>
        <ContentInputField
          name={
            productbase === "MACHINERY"
              ? detail?.productDetails?.machineryType?.hn === "Equipment"
                ? "Equipment"
                : "Machinery"
              : "Product" + " Name Hindi"
          }
          disabled={true}
          value={detail?.name?.hn}
        />
      </Col>

      <Col xs={12} lg={8}>
        <ContentInputField
          name={
            productbase === "MACHINERY"
              ? detail?.productDetails?.machineryType?.pb === "Equipment"
                ? "Equipment"
                : "Machinery"
              : "Product" + " Name Punjabi"
          }
          disabled={true}
          value={detail?.name?.pb}
        />
      </Col>

      {productbase === "MACHINERY" && (
        <Col xs={12} lg={8}>
          <SelectOption
            isMulti
            value={detail?.productDetails?.farmingOperations?.map((farm) => {
              return {
                label: farm?.en,
                value: farm?.en,
              };
            })}
            isDisabled={true}
            placeholder="Farming Operations"
          />
        </Col>
      )}

      <Col xs={12} lg={8}>
        <label className="font-weight-bolder font-size-md">
          Apni Kheti Product Review Video
        </label>
        <a
          className="border border-1 border-light-dark d-block p-2 rounded text-ellipsis white-nowrap overflow-hidden h-35px"
          target="_blank"
          href={detail?.about?.apniKhetiProductReview?.videoUrl}
        >
          {detail?.about?.apniKhetiProductReview?.videoUrl}
        </a>
      </Col>

      <Col xs={12} lg={8}>
        <label className="font-weight-bolder font-size-md">
          How to Use (Vendor) En
        </label>
        <a
          className="border border-1 border-light-dark d-block p-2 rounded text-ellipsis white-nowrap overflow-hidden h-35px"
          target="_blank"
          href={detail?.about?.howToUse?.videoUrls?.en}
        >
          {detail?.about?.howToUse?.videoUrls?.en}
        </a>
      </Col>

      <Col xs={12} lg={8}>
        <label className="font-weight-bolder font-size-md">
          How to Use (Vendor) Hn
        </label>
        <a
          className="border border-1 border-light-dark d-block p-2 rounded text-ellipsis white-nowrap overflow-hidden h-35px"
          target="_blank"
          href={detail?.about?.howToUse?.videoUrls?.hn}
        >
          {detail?.about?.howToUse?.videoUrls?.hn}
        </a>
      </Col>
      <Col xs={12} lg={8}>
        <label className="font-weight-bolder font-size-md">
          How to Use (Vendor) Pb
        </label>
        <a
          className="border border-1 border-light-dark d-block p-2 rounded text-ellipsis white-nowrap overflow-hidden h-35px"
          target="_blank"
          href={detail?.about?.howToUse?.videoUrls?.pb}
        >
          {detail?.about?.howToUse?.videoUrls?.pb}
        </a>
      </Col>
    </Row>
  );
};

export default FullDetails;